import { Injectable } from '@angular/core';
import {INotifications} from "../domain/INotifications";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  msgs: INotifications[];
  cardActivationMsgPush: boolean;
  accountStatusMsgPush: boolean;
  constructor() {
    this.msgs = [];
  }

}
